const API_BASE = "/api";

export const extractErrorMessage = (body: unknown, status: number): string => {
  if (typeof body === "object" && body !== null) {
    const b = body as Record<string, unknown>;
    const e = b["error"];
    if (typeof e === "string") return e;
    if (typeof e === "object" && e !== null) {
      const nested = e as Record<string, unknown>;
      if (typeof nested["message"] === "string") return nested["message"];
      if (typeof nested["code"] === "string") return nested["code"];
    }
  }
  return `HTTP ${status}`;
};

export const createApiRequest = (fetchFn: typeof fetch, onUnauthorized: () => void) => {
  return async function request<T>(path: string, init?: RequestInit): Promise<T> {
    const res = await fetchFn(`${API_BASE}${path}`, {
      headers: { "Content-Type": "application/json", ...init?.headers },
      ...init
    });
    if (!res.ok) {
      if (res.status === 401) {
        onUnauthorized();
      }
      const body = await res.json().catch(() => ({}));
      throw new Error(extractErrorMessage(body, res.status));
    }
    return res.json() as Promise<T>;
  };
};

export const createApiClient = (request: ReturnType<typeof createApiRequest>) => ({
  get<T>(path: string) {
    return request<T>(path);
  },
  post<T>(path: string, body: unknown) {
    return request<T>(path, { method: "POST", body: JSON.stringify(body) });
  },
  patch<T>(path: string, body: unknown) {
    return request<T>(path, { method: "PATCH", body: JSON.stringify(body) });
  }
});

export const api = createApiClient(
  createApiRequest(globalThis.fetch.bind(globalThis), () => {
    window.location.href = "/sign-in";
  })
);
